import { getClockDrift } from '../../services';
import type { AppDispatch } from '../../stores/redux';
import { getLogger } from '../../libs/logger';
import { createAsyncThunk } from '@reduxjs/toolkit';

const logger = getLogger('initClock');

/**
 * Pre-fetch the difference between user's clock and server clock.
 * Also observe the clock drift in DataDog.
 */
export const initClock = createAsyncThunk<
  // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
  void,
  undefined,
  { dispatch: AppDispatch }
>('initClock', async (_payload, { dispatch }) => {
  try {
    const drift = await dispatch(getClockDrift.initiate()).unwrap();

    logger.info(`Clock drift ${drift.toFixed(0)} ms`, { drift });
  } catch {
    logger.error('Failed to get current time from server');
  }
});
